import { Button } from "@/components/ui/button";

export const card = "border-2 border-[#14304F] bg-white";
export const label = "block text-[10px] font-mono uppercase tracking-[0.18em] text-zinc-500 mb-1";
export const input = "w-full border-2 border-zinc-300 focus:border-[#2F6DA3] focus:outline-none px-3 py-2 text-sm";

const TONES = {
  approved: "bg-emerald-100 text-emerald-800 border-emerald-300",
  signed: "bg-emerald-100 text-emerald-800 border-emerald-300",
  "Verified and Operational": "bg-emerald-100 text-emerald-800 border-emerald-300",
  closed: "bg-emerald-100 text-emerald-800 border-emerald-300",
  in_review: "bg-amber-100 text-amber-800 border-amber-300",
  issued: "bg-sky-100 text-sky-800 border-sky-300",
  draft: "bg-zinc-100 text-zinc-700 border-zinc-300",
  critical: "bg-red-600 text-white border-red-700",
  high: "bg-red-100 text-red-800 border-red-300",
  required: "bg-red-100 text-red-800 border-red-300",
  "Not Implemented": "bg-red-100 text-red-800 border-red-300",
  "Unknown / Insufficient Evidence": "bg-orange-100 text-orange-800 border-orange-300",
  "Legal Review Required": "bg-violet-100 text-violet-800 border-violet-300",
  "Not Applicable": "bg-zinc-50 text-zinc-500 border-zinc-200",
};

export const Pill = ({ value, testid }) => (
  <span data-testid={testid} className={`inline-block text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 border ${TONES[value] || "bg-zinc-50 text-zinc-600 border-zinc-300"}`}>
    {String(value ?? "—").replace(/_/g, " ")}
  </span>
);

export const SectionTitle = ({ children, sub }) => (
  <div className="mb-4">
    <h2 className="font-display text-xl font-extrabold tracking-tight text-[#14304F]">{children}</h2>
    {sub && <p className="text-sm text-zinc-500 mt-1 max-w-3xl">{sub}</p>}
  </div>
);

export const Act = ({ children, tone = "primary", ...p }) => (
  <Button
    size="sm"
    {...p}
    className={`font-bold uppercase tracking-wider text-xs ${
      tone === "primary" ? "bg-[#2F6DA3] hover:bg-[#234E74] text-white" : tone === "danger" ? "bg-red-700 hover:bg-red-800 text-white" : "bg-white text-[#14304F] border-2 border-[#14304F] hover:bg-zinc-50"
    }`}
  >
    {children}
  </Button>
);

export const Field = ({ name, spec = {}, value, onChange, testid }) => {
  const common = { "data-testid": testid, value: value ?? "", onChange: (e) => onChange(name, e.target.value), className: input };
  let el;
  if (spec.enum) {
    el = (
      <select {...common}>
        <option value="">—</option>
        {spec.enum.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    );
  } else if ((spec.max || 0) > 300) el = <textarea rows={3} {...common} />;
  else el = <input type={spec.type === "date" ? "date" : "text"} {...common} />;
  return (
    <div>
      <label className={label}>{name.replace(/_/g, " ")}</label>
      {el}
    </div>
  );
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : "Something went wrong";
};
